export default __webpack_public_path__ + "static/media/coinsBackground.85bbc802.png";